import { useOfferPageContext } from 'pages/offer/context';
import { getWordEnding } from 'shared/lib';
import { CardVariant } from '../types';
import { Typography, TypographyType, TypographyColor, TypographyFontWeight } from './typography';
import { Spacing, SpacingSize, SpacingDirection } from './spacing';
import styles from './position.module.scss';
import { Card } from '.';

/**
 * Position Overview
 */
export const Position = () => {
  const {
    userData: {
      position,
      organizationalUnitName,
      employmentContract,
      managerName,
      managerPosition,
      workSchedule,
      workFormat,
      paidAnnualLeave,
      location,
      equipmentProvided,
    },
  } = useOfferPageContext();

  const dayWord = getWordEnding(Number(paidAnnualLeave), ['день', 'дня', 'дней']);

  return (
    <Spacing size={SpacingSize.medium} direction={SpacingDirection.vertical} className={styles.position}>
      <Typography type={TypographyType.h2}>Позиция</Typography>

      <Spacing size={SpacingSize.small} direction={SpacingDirection.vertical} className={styles.rowSpacing}>
        <Spacing size={SpacingSize.small} direction={SpacingDirection.both} className={styles.positionTopBlocks}>
          <Card variant={CardVariant.secondary} className={styles.positionBlock}>
            <Typography type={TypographyType.h6} color={TypographyColor.titlePositionSecondary}>
              ДОЛЖНОСТЬ
            </Typography>

            <Typography type={TypographyType.h5} color={TypographyColor.white}>
              {position}
            </Typography>
          </Card>

          <Card className={styles.positionBlock}>
            <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
              ПРОДУКТ/ПРОЕКТ/ПОДРАЗДЕЛЕНИЕ
            </Typography>

            <Typography type={TypographyType.h5}>{organizationalUnitName}</Typography>
          </Card>
        </Spacing>

        <Spacing size={SpacingSize.small} direction={SpacingDirection.both} className={styles.positionMidBlocks}>
          <Card className={styles.positionBlock}>
            <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
              ВИД ТРУДОВОГО ДОГОВОРА
            </Typography>

            <Typography type={TypographyType.h5}>{employmentContract}</Typography>
          </Card>

          <Card variant={CardVariant.tertiary} className={styles.positionBlock}>
            <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
              РУКОВОДИТЕЛЬ
            </Typography>

            <Typography type={TypographyType.h5}>{managerName}</Typography>

            <Typography weight={TypographyFontWeight.medium} color={TypographyColor.textSecondary}>
              {managerPosition}
            </Typography>
          </Card>
        </Spacing>

        <Spacing size={SpacingSize.small} direction={SpacingDirection.both} className={styles.positionBottomBlocks}>
          <Card variant={CardVariant.tertiary} className={styles.positionBlock}>
            <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
              ГРАФИК РАБОТЫ
            </Typography>

            <Typography type={TypographyType.h5}>
              {workSchedule}, {workFormat}
            </Typography>
          </Card>

          <Card className={styles.positionBlock}>
            <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
              МЕСТО РАБОТЫ
            </Typography>

            <Typography type={TypographyType.h5}>{location}</Typography>
          </Card>

          <Card className={styles.positionBlock}>
            <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
              ОПЛАЧИВАМЫЙ ОТПУСК
            </Typography>

            <Typography type={TypographyType.h4} color={TypographyColor.textHighlight}>
              {paidAnnualLeave}
            </Typography>

            <Typography type={TypographyType.h5}>{dayWord} в году</Typography>
          </Card>

          {equipmentProvided && (
            <Card className={styles.positionBlock}>
              <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
                ОБОРУДОВАНИЕ
              </Typography>

              <Typography type={TypographyType.h5}>{equipmentProvided}</Typography>
            </Card>
          )}
        </Spacing>
      </Spacing>
    </Spacing>
  );
};
